"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    checkAllTeacherModal: {
        title: 'Select All Teachers',
        message: "We're fetching teachers to share with, this may take a few moments",
        labels: {
            select: 'Yes, Select',
            cancel: 'No, Cancel',
        },
    },
};
